import React from 'react';

const NavigationDashboardTab = ({ activeTab, setActiveTab, navTabs }) => {
	return (
		<div>
			<ul className="nav">
				{navTabs.map((item, index) => (
					<li
						key={index}
						className="nav-item"
					>
						<a
							className={`nav-link ${activeTab === item ? 'active' : ''} cursur-pointer fs-4 font-semibold`}
							style={{ cursor: 'pointer' }}
							onClick={() => {
								setActiveTab(item);
							}}
						>
							{item}
						</a>
					</li>
				))}
			</ul>
		</div>
	);
};

export default NavigationDashboardTab;
